// extracted by mini-css-extract-plugin
module.exports = {"skAdaptiveHeader":"Header-module--skAdaptiveHeader--33rgg","sklogo":"Header-module--sklogo--3S59-","versionLink":"Header-module--versionLink--3_89w"};